import Vue from 'vue'
import VueRouter from 'vue-router'
import { isSystem, requestWxStr } from '@/utils/custom';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '杉付宝' },
    component: () => import('@/views/index.vue')
  },
  {
    path: '/richText',
    name: 'RichText',
    meta: { title: '协议' },
    component: () => import('@/views/richText.vue')
  },
  {
    path: '/download',
    name: 'Download',
    meta: { title: '下载' },
    component: () => import('@/views/download.vue')
  },
	{
		path: '/text',
		name: 'text',
		meta: { title: '协议' },
		component: () => import('@/views/text.vue')
	}
]

const router = new VueRouter({
  mode: 'hash',
	base: '/sfb-register/',
  routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
